import React from 'react';

import {SearchDatesField} from '../SearchDatesField';
import {SearchDestinationField} from '../SearchDestinationField';
import {SearchGuestsField} from '../SearchGuestsField';
import {SearchSubmitButton} from '../SearchSubmitButton';

import {useComponent} from './hooks';

import './SearchFields.less';

import '../SearchField/SearchField.less';

// eslint-disable-next-line complexity
function SearchFields() {
    const {
        className,
        innerClassName,
        includeInner,
        showDestinationField,
        showDatesField,
        showGuestsField,
        showSubmitButton
    } = useComponent();

    const fields = (
        <>
            {showDestinationField && (
                <SearchDestinationField/>
            )}
            {showDatesField && (
                <SearchDatesField/>
            )}
            {showGuestsField && (
                <SearchGuestsField/>
            )}
        </>
    );

    return (
        <div className={className}>
            {includeInner ? (
                <div className={innerClassName}>
                    {fields}
                </div>
            ) : fields}
            {showSubmitButton && (
                <SearchSubmitButton/>
            )}
        </div>
    );
}

export {SearchFields};
